import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { EventTypeService } from '../../../../core/services/eventType.service';

@Component({
    selector: 'rewards-modal',
    templateUrl: './rewards.modal.html',
    styleUrls: ['./rewards.modal.scss'],
    standalone: false
})

export class RewardsModalComponent implements OnInit {

  public eventCategories = [];
  selected;
  numberItem = 0;
  comment = '';
  constructor(public dialogRef: MatDialogRef<RewardsModalComponent>, public eventTypeService: EventTypeService) {

  }

  ngOnInit() {
    this.getEventType();
  }

  getEventType() {
    this.eventTypeService.getEventTypes().then((result: any) => {
      this.eventCategories = result.map((res: any) => {
        return {label: res.name, value: res.id , color: res.color};
      });
    });
  }

  add() {
    if (this.numberItem !== 0 && this.selected) {
      this.dialogRef.close({eventType: this.selected, credits: this.numberItem, comment: this.comment});
    }
  }
}
